export const isNullish = <T>(value: T | undefined | null): value is undefined | null =>
  value === undefined || value === null;
